import { createPartnerAdminApiStore } from '@/api'
import config from '@/config'

const apiStore = createPartnerAdminApiStore([
  {
    action: '_penaltyProducts', // 상품관리 리스트
    path: 'v2/partnerPenalty/products',
    method: 'get',
    cacheable: false
  },
  {
    action: '_penaltyProductDetail', // 상품관리 리스트
    path: 'v2/partnerPenalty/products/{productNo}',
    pathParams: ['productNo'],
    method: 'get',
    cacheable: false
  },
  {
    action: '_penaltyPartners', // 파트너사 관리 리스트
    path: 'v2/partnerPenalty/partners',
    method: 'get',
    cacheable: false
  }
])

const PAGE_DATA = () => {
  return {
    pageIndex: 1,
    pageCount: 30,
    format: ''
  }
}

const SEARCH_DATA = () => {
  return {
    beginAt: null,
    endAt: null,
    year: null,
    months: []
  }
}

const INIT_DATA = () => {
  return Object.assign({}, SEARCH_DATA(), PAGE_DATA())
}

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    listParams: INIT_DATA(),
    total: 0
  },
  actions: {
    getPenaltyProducts ({state, getters, dispatch, commit}, params) {
      return dispatch('_penaltyProducts', {params: Object.assign({}, getters.listParams, params)})
    },
    getPenaltyProductDetail ({state, getters, dispatch, commit}, params) {
      return dispatch('_penaltyProductDetail', {params: Object.assign({}, getters.listParams, params)})
    },
    getPenaltyPartners ({state, getters, dispatch, commit}, params) {
      return dispatch('_penaltyPartners', {params: Object.assign({}, getters.listParams, params)})
    },
  },
  mutations: {
    SET_SEARCH_PARAMS (state, params) {
      state.listParams.beginAt = params.beginAt
      state.listParams.endAt = params.endAt
      state.listParams.year = params.year
      state.listParams.months = params.months
    },
    SET_PAGE_PARAMS (state, params) {
      state.listParams.pageIndex = params.pageIndex
      state.listParams.pageCount = params.pageCount
      state.listParams.format = params.format
    },
    INIT (state) {
      state.listParams = INIT_DATA()
    }
  },
  getters: {
    listParams: (state, getters) => {
      return state.listParams
    },
    penaltyStatusTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.penaltyStatusTypeData))
    },
    saleStatusTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.saleStatusTypeData))
    },
    mailingStatusData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.mailingStatusData))
    },
    penaltyPartnerStatusTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.penaltyPartnerStatusTypeData))
    },
    penaltyReasonTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.penaltyReasonTypeData))
    },
    stopReasonTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.stopReasonTypeData))
    },
    memoProductReasonTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.memoProductReasonTypeData))
    },
    memoPartnerReasonTypeData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.memoPartnerReasonTypeData))
    },
    productQueryTargetData () {
      return JSON.parse(JSON.stringify(config.defines.penalty.productQueryTargetData))
    }
  }
}
